import toast from 'react-hot-toast';
import { getUserFacingError } from '@/utils/errorMessages';

// Utility functions for common toast patterns used throughout the app

export const showSuccessToast = (message: string) => {
  return toast.success(message);
};

export const showErrorToast = (message: string) => {
  return toast.error(message);
};

export const showLoadingToast = (message: string) => {
  return toast.loading(message);
};

export const showToast = (message: string, type: 'success' | 'error' | 'loading' = 'success') => {
  switch (type) {
    case 'success':
      return toast.success(message);
    case 'error':
      return toast.error(message);
    case 'loading':
      return toast.loading(message);
    default:
      return toast(message);
  }
};

export const showPromiseToast = <T>(
  promise: Promise<T>,
  messages: {
    loading: string;
    success: string;
    error: string;
  }
) => {
  return toast.promise(promise, messages);
};

// General API error handler.
// Never surfaces the raw (usually English) backend message: known error codes are
// mapped to German via getUserFacingError, everything else falls back to the
// caller's customMessage (or a generic German message).
export const handleAPIError = (error: unknown, customMessage?: string) => {
  console.error('API Error:', error);
  showErrorToast(getUserFacingError(error, customMessage ?? TOAST_MESSAGES.GENERAL_ERROR));
};

// Common toast messages used throughout the app
export const TOAST_MESSAGES = {
  LOGIN_SUCCESS: 'Erfolgreich angemeldet!',
  LOGIN_ERROR: 'Anmeldung fehlgeschlagen',
  LOGOUT_SUCCESS: 'Erfolgreich abgemeldet',
  CHAT_CREATED: 'Neuer Chat erstellt',
  CHAT_CREATE_ERROR: 'Fehler beim Erstellen eines neuen Chats',
  CHAT_CLOSED: 'Chat wurde erfolgreich archiviert',
  CHAT_CLOSE_ERROR: 'Fehler beim Schließen des Chats',
  MESSAGE_SEND_ERROR: 'Fehler beim Senden der Nachricht',
  LOADING_CHAT: 'Chat wird geladen...',
  LOADING_MESSAGES: 'Nachrichten werden geladen...',
  GENERAL_ERROR: 'Ein unerwarteter Fehler ist aufgetreten',
  LOADING_SESSIONS: 'Chat-Sitzungen werden geladen...',
  SESSIONS_LOAD_ERROR: 'Fehler beim Laden der Chat-Sitzungen',
  MESSAGES_LOAD_ERROR: 'Fehler beim Laden der Nachrichten',
  USER_LOAD_ERROR: 'Fehler beim Laden der Benutzerdaten',
} as const;